module.exports = __webpack_public_path__ + "static/assets/default-logo.0df12ab.png";